import { render, staticRenderFns } from "./upload-records.vue?vue&type=template&id=c4c13428&scoped=true&"
import script from "./upload-records.vue?vue&type=script&lang=ts&"
export * from "./upload-records.vue?vue&type=script&lang=ts&"
import style0 from "./upload-records.vue?vue&type=style&index=0&id=c4c13428&prod&lang=scss&"
import style1 from "./upload-records.vue?vue&type=style&index=1&id=c4c13428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c13428",
  null
  
)

export default component.exports